import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ApiCoverageDetail, ApiQuoteResponse } from '@bhtp-client-api/base';
import { SelectedCoveragePipe } from './selected-coverage-pipe';

@Component({
    selector: 'package-coverage-summary',
    template: require('./package-coverage-summary.component.html')
})
export class PackageCoverageSummaryComponent {
    @Input() public product: ApiQuoteResponse;
    @Input() public wasPurchased: boolean = false;
    @Input() public showingPurchasedOptionalCoverages: boolean = false;
    @Input() public showHeader: boolean = true;
    @Input() public canShowOptionalCoverages: boolean = false;

    constructor() {
    }

    public get claimPayout(): string {
        return this.product.package.claimPayout ? this.product.package.claimPayout.join(', ') : null;
    }

    public get showOptionalCoverages(): boolean {
        if (this.product.coverages.optional) {
            return this.product.coverages.optional.filter(f => {
                return f.isSelected;
            }).length > 0 || this.canShowOptionalCoverages;
        }

        return false;
    }

    public getOptionalCoverages(): ApiCoverageDetail[] {
        if (this.product.coverages.optional) {
            if (this.canShowOptionalCoverages) {
                return this.product.coverages.optional;
            }

            return new SelectedCoveragePipe().transform(this.product.coverages.optional);
        }

        return [];
    }

    public get showIncludedCoverages(): boolean {
        return this.product.coverages.included ? this.product.coverages.included.length > 0 : false;
    }

    public get displayPayoutTypeOnCoverages(): boolean {
        return this.product.package.displayPayoutTypeOnCoverages;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/package-coverage-summary.component.ts